import {
  ArrayInput,
  AutocompleteInput,
  FormDataConsumer,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
  useSimpleFormIteratorItem,
} from "react-admin";
import { Grid } from "@mui/material";
import { CAMPAIGNS, OPTIONS, RECEPTION_TYPES, SpecialistServicePath, SPECIALIZATIONS } from "utils/constants";
import { SectionTitle } from "features/SectionTitle";
import { settings } from "app";

const SpecializationsForm = ({ isMobile, campaignId, isEmployee }) => {
  const IndexField = () => {
    const { index } = useSimpleFormIteratorItem();
    return (
      <NumberInput
        disabled
        sx={{ display: "none" }}
        source="priority"
        label="Приоритет"
        defaultValue={index + 1}
      />
    );
  };

  return (
    <Grid
      container
      spacing={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
      >
        <SectionTitle paddingY={2} title={"Специализации"} />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <ArrayInput
          source="specializationOptions"
          label="Добави специализации"
          validate={[required()]}
        >
          <SimpleFormIterator>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={6}
                xl={4}
              >
                <ReferenceInput
                  source="specializationId"
                  reference={`${SpecialistServicePath}${CAMPAIGNS}/${campaignId}/${SPECIALIZATIONS}`}
                  filter={{ IsEmployeeOnly: isEmployee }}
                >
                  <AutocompleteInput
                    validate={[required()]}
                    optionText="nameBg"
                    label="Специалност"
                    fullWidth
                    filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                  />
                </ReferenceInput>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                xl={4}
              >
                <FormDataConsumer>
                  {({ scopedFormData }) =>
                    scopedFormData?.specializationId && (
                      <ReferenceInput
                        source={"receptionTypeId"}
                        reference={`${SpecialistServicePath}${CAMPAIGNS}/${campaignId}/${SPECIALIZATIONS}/${scopedFormData.specializationId}/${RECEPTION_TYPES}`}
                        filter={{ IsEmployeeOnly: isEmployee }}
                      >
                        <SelectInput
                          validate={[required()]}
                          label="Тип прием"
                          optionText={"nameBg"}
                          fullWidth
                        />
                      </ReferenceInput>
                    )
                  }
                </FormDataConsumer>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                xl={4}
              >
                <FormDataConsumer>
                  {({ scopedFormData }) =>
                    scopedFormData?.receptionTypeId &&
                    scopedFormData?.specializationId && (
                      <ReferenceInput
                        source={"campaignSpecializationOptionId"}
                        reference={`${SpecialistServicePath}${CAMPAIGNS}/${campaignId}/${SPECIALIZATIONS}/${OPTIONS}`}
                        filter={{
                          IsEmployeeOnly: isEmployee,
                          SpecializationId: scopedFormData.specializationId,
                          ReceptionTypeId: scopedFormData.receptionTypeId,
                        }}
                      >
                        <SelectInput
                          validate={[required()]}
                          label="Специализационна опция"
                          optionText={"specializationNameBg"}
                          fullWidth
                        />
                      </ReferenceInput>
                    )
                  }
                </FormDataConsumer>

                <IndexField />
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  );
};
export default SpecializationsForm;
